import { useQuery } from "@tanstack/react-query"

import { SupplierResponses } from "@tfg/types/endpoints/supplier"

import { httpClient } from "~/backend/axios.ts"

export const useListSupplierProductionSitesQuery = () => {
  return useQuery({
    queryKey: ["listProductionSites"],
    queryFn: async () =>
      (
        await httpClient.get<SupplierResponses.ProductionSite[]>(
          `supplier/production-sites`
        )
      ).data,
  })
}
